import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { scVarTransitionDuration } from '@utils/emotion/variables';
import { useTranslation } from 'react-i18next';
import { Upload as AntdUpload, message } from 'antd';
import { RcFile } from 'antd/lib/upload';
import { UploaderContext } from '~/lib/video-uploader';
import { ReactComponent as IconUpload } from '@svg/icon-upload-basic.svg';

const { Dragger } = AntdUpload;

const CardUploadV2: React.FC = () => {
  const { t } = useTranslation();
  const videoUploader = useContext(UploaderContext);

  const handleBeforeUpload = (file: RcFile) => {
    if (file.name.endsWith('.mkv') && file.type === '') return true;
    switch (file.type) {
      case 'video/mp4':
      case 'video/webm':
      case '.mkv':
      case 'video/quicktime':
      case 'video/x-msvideo':
      case 'video/x-flv':
        return true;
      default:
        message.error(t('upload.error.format'));
        return false;
    }
  };

  return (
    <CardBlock className="card-item">
      <div className="content">
        <strong className="title">{t('home.grant.heading')}</strong>
        <p className="desc">{t('home.grant.desc')}</p>
        <div className="dropzone-area">
          <div className="dropzone">
            <Dragger
              name="video"
              multiple
              showUploadList={false}
              beforeUpload={handleBeforeUpload}
              customRequest={(options) => videoUploader.createVideoUpload(options)}
            >
              <div className="dropzone-inner">
                <IconUpload width="40" height="49" />
                <p className="drag-guide">{t('home.grant.guideline.drag2')}</p>
              </div>
            </Dragger>
          </div>
        </div>
      </div>
    </CardBlock>
  );
};

const CardBlock = styled.div`
  position: relative;
  width: 350px;
  padding: 22px;
  background-color: ${({ theme }) => theme.colors.secondary.bgColor};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  transition: background-color ${scVarTransitionDuration} ease;

  .content {
    .title {
      font-size: 18px;
      line-height: 1.5;
    }

    .desc {
      overflow: hidden;
      margin-top: 14px;
      font-size: 12px;
      line-height: 1.5;
      white-space: pre-wrap;
    }
  }

  .dropzone-area {
    position: relative;
    margin-top: 22px;

    .ant-upload-drag {
      padding: 0;
      border-color: #c2cfe0;
      background: rgba(81, 0, 206, 0);
      transition: all 200ms ease;

      &:hover,
      &.ant-upload-drag-hover {
        background-color: rgba(194, 207, 224, 0.1);
        border-color: #c2cfe0;
      }
    }

    .dropzone-inner {
      padding: 0;

      svg {
        position: relative;
        top: 2px;
        margin-right: 8px;

        path {
          fill: #c2cfe0;
        }
      }

      .ant-btn {
        width: 160px;
        font-size: 14px;
      }

      .drag-guide {
        margin: 8px;
        padding: 0 24px;
        color: #c2cfe0;
        font-weight: bold;
        font-size: 14px;
        line-height: 1.5;
        white-space: pre;
      }
    }
  }

  .button-area {
    position: absolute;
    top: 0;
    right: 0;
  }

  .dropzone {
    height: 168px;
  }
`;

export default CardUploadV2;
